import {fabric} from "fabric";
import {db} from "./firebase-services";
import {setAddedPremadesIds} from "../ducks/premades";
import {useCallback} from "react";
import {shallowEqual, useSelector} from "react-redux";
import {icons} from "../svgIcons";

export function usePremades ()
{
	const canvas = useSelector(state => state.canvas.canvas, shallowEqual);

	const addedPremadesIds = useSelector(state => state.premades.addedPremadesIds, shallowEqual);

	const addPremadeOnCanvas = useCallback((premade) =>
	{
		let halfWindow = 800;

		if (premade.svg)
		{
			fabric.loadSVGFromURL('/assets/svg/' + premade.name + '.svg', function(objects, options) {

				let formattedObjects = objects.map(object => {
					object.set('fill', '#eaff00');
					return object;
				});

				let obj = fabric.util.groupSVGElements(formattedObjects, options);
				if (obj.left < halfWindow)
				{
					obj.left = halfWindow;
				}
				obj.isSvg = true;

				canvas.add(obj);
			});
		}
		else
		{
			fabric.util.enlivenObjects([JSON.parse(premade.data)], function(objects) {
				let formattedObjects = objects.map(object => {
					if (object.left < halfWindow)
					{
						object.left = halfWindow;
					}
					return object;
				});
				canvas.add(...formattedObjects);
			});
		}

		if (addedPremadesIds.indexOf(premade.id) === -1)
		{
			setAddedPremadesIds([...addedPremadesIds, premade.id]);
		}

		canvas.renderAll();
	}, [canvas, addedPremadesIds]);

	return {addPremadeOnCanvas};
}

export const exportPNG = function (callback)
{
	function trimCanvas (canvas)
	{
		let ctx = canvas.getContext('2d'),
			w = canvas.width,
			h = canvas.height,
			pix = {x:[], y:[]}, n,
			imageData = ctx.getImageData(0, 0, w, h),
			fn = function(a,b) { return a - b };

		console.log(w, h, imageData);
		for (let y = 0; y < h; y++)
		{
			for (let x = 0; x < w; x++)
			{
				if (imageData.data[((y * w + x) * 4)+3] > 0)
				{
					pix.x.push(x);
					pix.y.push(y);
				}
			}
		}

		pix.x.sort(fn);
		pix.y.sort(fn);
		n = pix.x.length - 1;

		w = pix.x[n] - pix.x[0];
		h = pix.y[n] - pix.y[0];

		console.log(pix.x[0], pix.y[0], w, h);
		//let cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);

		canvas.width = w;
		canvas.height = h;
		ctx.putImageData(imageData, 0, 0);
	}


	const originalZoom = this.canvas.getZoom();
	//this.canvas.setZoom(1);

	let json = JSON.stringify(this),
		canvas = fabric.util.createCanvasElement();

	//this.canvas.setZoom(originalZoom);

	canvas.width = this.getScaledWidth();
	canvas.height = this.getScaledHeight();

	let fcanvas = new fabric.Canvas(canvas, {enableRetinaScaling : false});

	fabric.util.enlivenObjects([JSON.parse(json)], function(objects) {
		objects.forEach(function(o) {
			//o.top -= bound.top;
			//o.left -= bound.left;
			o.top = 0;
			o.left = 0;
			fcanvas.add(o);
		});
		fcanvas.renderAll();

		let canvas = fcanvas.getElement();
		//trimCanvas(canvas);

		canvas.toBlob(function(blob) {
			let reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = () => callback(reader.result);
		}, 'image/png');
	});
};

export async function savePremade (name, premadeData, isPrivate, user = null)
{
	const currentDate = Date.now();

	try
	{
		let data = {name, ...premadeData, score: 0, isPrivate, createDate: currentDate, lastUpdateDate: currentDate, uses : []};
		if (user !== null)
		{
			data.createdBy = user.id;

			if (user.funnyName)
			{
				data.createdByName = user.funnyName;
			}

			if (user.company)
			{
				data.createdByCompany = user.company;
			}
		}

		const docRef = await db.collection("premades").add(data);
		return docRef.id;
	}
	catch (e)
	{
		console.error("Error adding premade: ", e);
		return null;
	}
	finally
	{

	}
}

export async function updatePremadesScore (premadesIds, user = null)
{
	if (premadesIds.length === 0)
	{
		return;
	}

	const currentDate = Date.now();

	try
	{
		const [docs, _] = await loadPremadesFromDb(premadesIds);
		const batchArray = [];
		batchArray.push(db.batch());
		let operationCounter = 0;
		let batchIndex = 0;

		docs.forEach(doc => {

			let uses = doc.uses || [],
				update = {score : doc.score + 1, lastUpdateDate : currentDate};

			if (user && uses.indexOf(user.id) === -1)
			{
				uses.push(user.id);
				update.uses = uses;
			}

			batchArray[batchIndex].update(db.doc(`premades/${doc.id}`), update);

			operationCounter++;

			if (operationCounter === 499) {
				batchArray.push(db.batch());
				batchIndex++;
				operationCounter = 0;
			}
		});

		batchArray.forEach(async batch => await batch.commit());
	}
	catch (e)
	{
		console.error("Error updating premades: ", e);
		return null;
	}
	finally
	{

	}
}

export async function loadPremadesFromDb (premadesIds = [], user = null, company = null, search = null, startAfter = null, limit = 0)
{
	try
	{
		let docsQuery1,
			docsQuery2;

		if (premadesIds.length === 0)
		{
			docsQuery1 = db.collection("premades").orderBy(search ? 'name' : 'score', 'desc');

			if (user !== null)
			{
				docsQuery1 = docsQuery1.where('createdBy', '==', user.id);
				docsQuery2 = db.collection("premades").orderBy(search ? 'name' : 'score', 'desc').where("uses", "array-contains", user.id.toString());
			}

			if (company !== null)
			{
				docsQuery1 = docsQuery1.where('createdByCompany', '==', company);
			}

			if (search)
			{
				docsQuery1 = docsQuery1.where('name', '>=', search).where('name', '<=', search + '~');
				if (docsQuery2)
				{
					docsQuery2 = docsQuery2.where('name', '>=', search).where('name', '<=', search + '~');
				}
			}


			if (startAfter !== null)
			{
				docsQuery1 = docsQuery1.startAfter(startAfter);
			}

			if (limit !== 0)
			{
				docsQuery1 = docsQuery1.limit(limit);
			}
		}
		else
		{
			docsQuery1 = db.collection("premades").where('__name__', 'in', premadesIds);
		}

		const querySnapshot1 = await docsQuery1.get();
		const lastDoc = querySnapshot1.docs[querySnapshot1.docs.length - 1] || null;
		let docs = querySnapshot1.docs.map(doc => {return {id: doc.id, ...doc.data()};});

		if (docsQuery2)
		{
			const querySnapshot2 = await docsQuery2.get();
			let additionalDocs = querySnapshot2.docs.map(doc => {return {id: doc.id, ...doc.data()};});
			docs = [...docs, ...additionalDocs.filter(doc => docs.find(existingDoc => existingDoc.id === doc.id) === undefined)];
		}

		return [docs, lastDoc];
	}
	catch (e)
	{
		console.error("Error getting premades: ", e);
		return null;
	}
	finally
	{

	}
}

export async function countPremades ()
{
	try
	{
		let docsQuery1 = db.collection("premades").orderBy('score', 'desc');
		const querySnapshot = await docsQuery1.get();
		return querySnapshot.size + icons.length;
	}
	catch (e)
	{
		console.error("Error counting premades: ", e);
		return null;
	}
	finally
	{

	}
}

export function generateFunnyName ()
{
	var userNameColor = [ "White", "Yellow", "Blue", "Red", "Green", "Black", "Brown", "Azure", "Ivory", "Teal", "Silver", "Purple", "Navy blue", "Pea green", "Gray", "Orange", "Maroon", "Charcoal", "Aquamarine", "Coral", "Fuchsia", "Wheat", "Lime", "Crimson", "Khaki", "Hot pink", "Magenta", "Olden", "Plum", "Olive", "Cyan" ];
	var userNameAnimal = [ "Aardvark", "Abyssinian", "Adelie Penguin", "Affenpinscher", "Afghan Hound", "African Bush Elephant", "African Civet", "African Clawed Frog", "African Forest Elephant", "African Palm Civet", "African Penguin", "African Tree Toad", "African Wild Dog", "Ainu Dog", "Airedale Terrier", "Akbash", "Akita", "Alaskan Malamute", "Albatross", "Aldabra Giant Tortoise", "Alligator", "Alpine Dachsbracke", "American Bulldog", "American Cocker Spaniel", "American Coonhound", "American Eskimo Dog", "American Foxhound", "American Pit Bull Terrier", "American Staffordshire Terrier", "American Water Spaniel", "Amur Leopard", "Anatolian Shepherd Dog", "Angelfish", "Ant", "Anteater", "Antelope", "Appenzeller Dog", "Arctic Fox", "Arctic Hare", "Arctic Wolf", "Armadillo", "Asian Elephant", "Asian Giant Hornet", "Asian Palm Civet", "Asiatic Black Bear", "Australian Cattle Dog", "Australian Kelpie Dog", "Australian Mist", "Australian Shepherd", "Australian Terrier", "Avocet", "Axolotl", "Aye Aye", "Baboon", "Bactrian Camel", "Badger", "Balinese", "Banded Palm Civet", "Bandicoot", "Barb", "Barn Owl", "Barnacle", "Barracuda", "Basenji Dog", "Basking Shark", "Basset Hound", "Bat", "Bavarian Mountain Hound", "Beagle", "Bear", "Bearded Collie", "Bearded Dragon", "Beaver", "Bedlington Terrier", "Beetle", "Bengal Tiger", "Bernese Mountain Dog", "Bichon Frise", "Binturong", "Bird", "Birds Of Paradise", "Birman", "Bison", "Black Rhinoceros", "Black Russian Terrier", "Black Widow Spider", "Bloodhound", "Blue Lacy Dog", "Blue Whale", "Bluetick Coonhound", "Bobcat", "Bolognese Dog", "Bombay", "Bongo", "Bonobo", "Booby", "Border Collie", "Border Terrier", "Bornean Orang-utan", "Borneo Elephant", "Boston Terrier", "Bottlenose Dolphin", "Boxer Dog", "Boykin Spaniel", "Brazilian Terrier", "Brown Bear", "Budgerigar", "Buffalo", "Bull Mastiff", "Bull Shark", "Bull Terrier", "Bulldog", "Bullfrog", "Bumble Bee", "Burmese", "Burrowing Frog", "Butterfly", "Butterfly Fish", "Caiman", "Caiman Lizard", "Cairn Terrier", "Camel", "Canaan Dog", "Capybara", "Caracal", "Carolina Dog", "Cassowary", "Cat", "Caterpillar", "Catfish", "Cavalier King Charles Spaniel", "Centipede", "Cesky Fousek", "Chameleon", "Chamois", "Cheetah", "Chesapeake Bay Retriever", "Chicken", "Chihuahua", "Chimpanzee", "Chinchilla", "Chinese Crested Dog", "Chinook", "Chinstrap Penguin", "Chipmunk", "Chow Chow", "Cichlid", "Clouded Leopard", "Clown Fish", "Clumber Spaniel", "Coati", "Cockroach", "Collared Peccary", "Collie", "Common Buzzard", "Common Frog", "Common Loon", "Common Toad", "Coral", "Cottontop Tamarin", "Cougar", "Cow", "Coyote", "Crab", "Crab-Eating Macaque", "Crane", "Crested Penguin", "Crocodile", "Cross River Gorilla", "Curly Coated Retriever", "Cuscus", "Cuttlefish", "Dachshund", "Dalmatian", "Darwin's Frog", "Deer", "Desert Tortoise", "Deutsche Bracke", "Dhole", "Dingo", "Discus", "Doberman Pinscher", "Dodo", "Dog", "Dogo Argentino", "Dogue De Bordeaux", "Dolphin", "Donkey", "Dormouse", "Dragonfly", "Drever", "Duck", "Dugong", "Dunker", "Dusky Dolphin", "Dwarf Crocodile", "Eagle", "Earwig", "Eastern Gorilla", "Eastern Lowland Gorilla", "Echidna", "Edible Frog", "Egyptian Mau", "Electric Eel", "Elephant", "Elephant Seal", "Elephant Shrew", "Emperor Penguin", "Emperor Tamarin", "Emu", "English Cocker Spaniel", "English Shepherd", "English Springer Spaniel", "Entlebucher Mountain Dog", "Epagneul Pont Audemer", "Eskimo Dog", "Estrela Mountain Dog", "Falcon", "Fennec Fox", "Ferret", "Field Spaniel", "Fin Whale", "Finnish Spitz", "Fire-Bellied Toad", "Fish", "Fishing Cat", "Flamingo", "Flat Coat Retriever", "Flounder", "Fly", "Flying Squirrel", "Fossa", "Fox", "Fox Terrier", "French Bulldog", "Frigatebird", "Frilled Lizard", "Frog", "Fur Seal", "Galapagos Penguin", "Galapagos Tortoise", "Gar", "Gecko", "Gentoo Penguin", "Geoffroys Tamarin", "Gerbil", "German Pinscher", "German Shepherd", "Gharial", "Giant African Land Snail", "Giant Clam", "Giant Panda Bear", "Giant Schnauzer", "Gibbon", "Gila Monster", "Giraffe", "Glass Lizard", "Glow Worm", "Goat", "Golden Lion Tamarin", "Golden Oriole", "Golden Retriever", "Goose", "Gopher", "Gorilla", "Grasshopper", "Great Dane", "Great White Shark", "Greater Swiss Mountain Dog", "Green Bee-Eater", "Greenland Dog", "Grey Mouse Lemur", "Grey Reef Shark", "Grey Seal", "Greyhound", "Grizzly Bear", "Grouse", "Guinea Fowl", "Guinea Pig", "Guppy", "Hammerhead Shark", "Hamster", "Hare", "Harrier", "Havanese", "Hawaiian Crow", "Hedgehog", "Hercules Beetle", "Hermit Crab", "Heron", "Highland Cattle", "Himalayan", "Hippopotamus", "Honey Bee", "Horn Shark", "Horned Frog", "Horse", "Horseshoe Crab", "Howler Monkey", "Human", "Humboldt Penguin", "Hummingbird", "Humpback Whale", "Hyena", "Ibis", "Ibizan Hound", "Iguana", "Impala", "Indian Elephant", "Indian Palm Squirrel", "Indian Rhinoceros", "Indian Star Tortoise", "Indochinese Tiger", "Indri", "Insect", "Irish Setter", "Irish WolfHound", "Jack Russel", "Jackal", "Jaguar", "Japanese Chin", "Japanese Macaque", "Javan Rhinoceros", "Javanese", "Jellyfish", "Kakapo", "Kangaroo", "Keel Billed Toucan", "Killer Whale", "King Crab", "King Penguin", "Kingfisher", "Kiwi", "Koala", "Komodo Dragon", "Kudu", "Labradoodle", "Labrador Retriever", "Ladybug", "Leaf-Tailed Gecko", "Lemming", "Lemur", "Leopard", "Leopard Cat", "Leopard Seal", "Leopard Tortoise", "Liger", "Lion", "Lionfish", "Little Penguin", "Lizard", "Llama", "Lobster", "Long-Eared Owl", "Lynx", "Macaroni Penguin", "Macaw", "Magellanic Penguin", "Magpie", "Maine Coon", "Malayan Civet", "Malayan Tiger", "Maltese", "Manatee", "Mandrill", "Manta Ray", "Marine Toad", "Markhor", "Marsh Frog", "Masked Palm Civet", "Mastiff", "Mayfly", "Meerkat", "Millipede", "Minke Whale", "Mole", "Molly", "Mongoose", "Mongrel", "Monitor Lizard", "Monkey", "Monte Iberia Eleuth", "Moorhen", "Moose", "Moray Eel", "Moth", "Mountain Gorilla", "Mountain Lion", "Mouse", "Mule", "Neanderthal", "Neapolitan Mastiff", "Newfoundland", "Newt", "Nightingale", "Norfolk Terrier", "North American Black Bear", "Norwegian Forest", "Numbat", "Nurse Shark", "Ocelot", "Octopus", "Okapi", "Old English Sheepdog", "Olm", "Opossum", "Orang-utan", "Ostrich", "Otter", "Oyster", "Pademelon", "Panther", "Parrot", "Patas Monkey", "Peacock", "Pekingese", "Pelican", "Penguin", "Pere Davids Deer", "Persian", "Pheasant", "Pied Tamarin", "Pig", "Pika", "Pike", "Pink Fairy Armadillo", "Piranha", "Platypus", "Pointer", "Poison Dart Frog", "Polar Bear", "Pond Skater", "Poodle", "Pool Frog", "Porcupine", "Possum", "Prawn", "Proboscis Monkey", "Puffer Fish", "Puffin", "Pug", "Puma", "Purple Emperor", "Puss Moth", "Pygmy Hippopotamus", "Pygmy Marmoset", "Quail", "Quetzal", "Quokka", "Quoll", "Rabbit", "Raccoon", "Raccoon Dog", "Radiated Tortoise", "Ragdoll", "Rat", "Rattlesnake", "Red Knee Tarantula", "Red Panda", "Red Wolf", "Red-handed Tamarin", "Reindeer", "Rhinoceros", "River Dolphin", "River Turtle", "Robin", "Rock Hyrax", "Rockhopper Penguin", "Roseate Spoonbill", "Rottweiler", "Royal Penguin", "Russian Blue", "Sabre-Toothed Tiger", "Saint Bernard", "Salamander", "Sand Lizard", "Saola", "Scimitar-horned Oryx", "Scorpion", "Scorpion Fish", "Sea Dragon", "Sea Lion", "Sea Otter", "Sea Slug", "Sea Squirt", "Sea Turtle", "Sea Urchin", "Seahorse", "Seal", "Serval", "Sheep", "Shih Tzu", "Shrimp", "Siamese", "Siamese Fighting Fish", "Siberian", "Siberian Husky", "Siberian Tiger", "Silver Dollar", "Skunk", "Sloth", "Slow Worm", "Snail", "Snake", "Snapping Turtle", "Snowshoe", "Snowy Owl", "Somali", "South China Tiger", "Spadefoot Toad", "Sparrow", "Spectacled Bear", "Sperm Whale", "Spider Monkey", "Spiny Dogfish", "Spixs Macaw", "Sponge", "Squid", "Squirrel", "Squirrel Monkey", "Sri Lankan Elephant", "Staffordshire Bull Terrier", "Stag Beetle", "Starfish", "Stellers Sea Cow", "Stick Insect", "Stingray", "Stoat", "Striped Rocket Frog", "Sumatran Elephant", "Sumatran Orang-utan", "Sumatran Rhinoceros", "Sumatran Tiger", "Sun Bear", "Swan", "Tang", "Tapanuli Orang-utan", "Tapir", "Tarsier", "Tasmanian Devil", "Tawny Owl", "Termite", "Tetra", "Thorny Devil", "Tibetan Mastiff", "Tiffany", "Tiger", "Tiger Salamander", "Tiger Shark", "Tortoise", "Toucan", "Tree Frog", "Tropicbird", "Tuatara", "Turkey", "Turkish Angora", "Uakari", "Uguisu", "Umbrellabird", "Vampire Bat", "Vervet Monkey", "Vulture", "Wallaby", "Walrus", "Warthog", "Wasp", "Water Buffalo", "Water Dragon", "Water Vole", "Weasel", "Welsh Corgi", "West Highland Terrier", "Western Gorilla", "Western Lowland Gorilla", "Whale Shark", "Whippet", "White Faced Capuchin", "White Rhinoceros", "White Tiger", "Wild Boar", "Wildebeest", "Wolf", "Wolverine", "Wombat", "Woodlouse", "Woodpecker", "Woolly Mammoth", "Woolly Monkey", "Wrasse", "Wyoming Toad", "X-Ray Tetra", "Yak", "Yellow-Eyed Penguin", "Yorkshire Terrier", "Zebra", "Zebra Shark", "Zebu", "Zonkey", "Zorse" ];
	return userNameColor[Math.floor(Math.random() * userNameColor.length)] + ' ' + userNameAnimal[Math.floor(Math.random() * userNameAnimal.length)]
}

fabric.Object.prototype.toObject = (function (toObject) {
	return function (properties) {
		return fabric.util.object.extend(toObject.call(this, properties), {
			firebaseId: this.firebaseId
		});
	};
})(fabric.Object.prototype.toObject);

